"use strict";

define('components/utils',['components/form'], function(form) {
    /*
     * This module contains various common JS helpers for declarative components.
     *
     * 1. Reveal/Hide toggle:
     *    Description: an anchor tag that can toggle the visibility of other elements on the page by adding/removing
     *                 the 'hidden' class.  Can also be used with radio buttons.
     *    Component selector: 'a.reveal-hidden, button.reveal-hidden'
     *    Data:
     *      'reveal-target' - selector for the element to reveal (ie. remove the 'hidden' class) on component click
     *      'hide-target' - selector for the element to hide (ie. add the 'hidden' class) on component click
     *
     * 2. Ajax button or anchor
     *    Description: A button or anchor that triggers an AJAX request on click.  Has no direct side-effects on the
     *                 DOM.  Users must rely on the side-effects available in the AJAX component.
     *    Component selector: '.ajax', '.ajax-get' can be added to make it a 'GET' request
     *    Data:
     *      'url' - URL to post the ajax request to.  Also falls back to data 'add-url'
                so it can be used on module headers and then 'href' attribute if 'data-url' is missing.
     *      'form' - Optionally serialize and submit the contents of this form.
     *
     * 3. Inline editing
     *
     * 4. Email address obfuscation
     *
     * 5. Trigger event:
     *    Description: A button or anchor that triggers an event on another DOM node on click.  The event must be one
     *                 that does not require any data (eg. click).
     *    Component selector: '.trigger'
     *    Data:
     *      'event-target' - selector for the element on which the event is triggered
     *      'event-type' - Javascript event type
     *
     * 6. Disable/Enable toggle:
     *    Description: a checkbox that can toggle the disabled state of another input
     *    Component selector: input[type=checkbox].toggle-disabled
     *    Data:
     *      'toggle-target' - selector for the element to reveal (ie. remove the 'hidden' class) on component click
     *      'hide-target' - selector for the element to hide (ie. add the 'hidden' class) on component click
     *
     * 7. Exclusive checkbox:
     *    Description: a checkbox that is mutually exclusive with all other checkboxes with the same name. When
     *                 checking a checkbox, all other checkboxes on the form with this name will get unchecked.
     *    Component selector: input[type=checkbox].exclusive-checkbox
     */

    var utils = {
        init: function (node) {
            this.initRevealHide(node);
            this.initAjaxButton(node);
            this.initDownloadButton(node);
            this.initInlineEdit(node);
            this.initObfuscatedAddress(node);
            this.initTrigger(node);
            this.initToggleDisabled(node);
            this.initSelectAll(node);
            this.initToggleChecked(node);
        },

        initRevealHide: function (node) {
            node.find('a.reveal-hidden, button.reveal-hidden').click(function(e) {
                e.preventDefault();
                var selectorToHide = $(this).data('hide-target');
                if (selectorToHide) {
                    $(selectorToHide).addClass('hidden');
                    if ($(this).data('clear-hidden') == 'content') {
                        $(selectorToHide).html('');
                    }else if ($(this).data('clear-hidden') == 'remove') {
                        $(selectorToHide).remove();
                    }
                } else {
                    $(this).addClass('hidden');
                }

                var selectorToReveal = $(this).data('reveal-target');
                $(selectorToReveal).removeClass('hidden');

                // inputs with class 'select-all' have their contents selected on focus
                $(selectorToReveal).find('input[type=text].select-all,textarea.select-all').click(function() {
                    $(this).select();
                });
            });

            node.find('input:radio.reveal-hidden').change(function(e) {
                if (!$(this).prop('checked'))
                    return;

                var selectorToReveal = $(this).data('reveal-target');
                var selectorToHide = $(this).data('hide-target');
                if (selectorToHide) {
                    $(selectorToHide).addClass('hidden');
                }
                $(selectorToReveal).removeClass('hidden');
            });

            node.find('input:checkbox.reveal-hidden').change(function(e) {
                var selectorToReveal = $(this).data('reveal-target');
                var selectorToHide = $(this).data('hide-target');
                if ($(this).prop('checked')) {
                    if (selectorToHide) {
                        $(selectorToHide).addClass('hidden');
                    }
                    $(selectorToReveal).removeClass('hidden');
                } else {
                    if (selectorToHide) {
                        $(selectorToHide).removeClass('hidden');
                    }
                    $(selectorToReveal).addClass('hidden');
                }
            });

            node.find('a.reveal-mobile-collapsed').click(function(e) {
                e.preventDefault();
                $(this).closest('.expand-on-mobile').addClass('hidden').removeClass('visible-xs-block')
                    .nextAll('.expand-on-mobile-target').first().removeClass('hidden-xs');
                $(this).addClass('hidden');
            });

            node.find('select.reveal-hidden').change(function(e) {
                var selectValueToReveal = $(this).data('reveal-value');
                if (!selectValueToReveal) {
                    return;
                }
                var selectorToHide = $(this).data('hide-target'),
                    selectedRevealOption = $(this).val() === selectValueToReveal;
                if (selectedRevealOption) {
                    var selectorToReveal = $(this).data('reveal-target');
                    $(selectorToReveal).removeClass('hidden');
                } else {
                    if (selectorToHide) {
                        $(selectorToHide).addClass('hidden');
                        if ($(this).data('clear-hidden') == 'value') {
                            $(selectorToHide).val('');
                            $(selectorToHide + ' input').each(function() { $(this).val(''); });
                        }
                        else if ($(this).data('clear-hidden') == 'content') {
                            $(selectorToHide).html('');
                        } else if ($(this).data('clear-hidden') == 'remove') {
                            $(selectorToHide).remove();
                        }
                    } else {
                        $(this).addClass('hidden');
                    }
                }
            });
        },

        initAjaxButton: function (node) {
            node.find('.ajax').click(function(e) {
                var button = $(this);
                if (button.hasClass('disabled')) {
                    return;
                }

                button.addClass('disabled');

                var type = button.hasClass('ajax-get') ? 'GET' : 'POST';

                e.preventDefault();

                var makeAjaxRequest = function(button, modalNode) {
                    require(['components/ajax'], function(ajax) {
                        var onComplete = function(result) {
                            if (typeof(modalNode) !== 'undefined' && !Object.prototype.hasOwnProperty.call(result, 'waiting_modal')) {
                                modalNode.modal('hide');
                            }

                            // Typically a page transition will
                            // happen after completion so wait 1 second
                            // before re-enabling to prevent user from
                            // clicking on the button during the page transition.
                            setTimeout(function() {
                                button.removeClass('disabled');
                            }, 1000);
                        };

                        // allows failure responses to add classes
                        var onFailure = function(result) {
                            if (result.classname) {
                                for (var selector in result.classname) {
                                    for (var action in result.classname[selector]) {
                                        if (action == 'add') {
                                            $(selector).addClass(result.classname[selector]['add']);
                                        } else if (action == 'remove') {
                                            $(selector).removeClass(result.classname[selector]['remove']);
                                        }
                                    }
                                }
                            }
                            // don't prevent default
                            return false;
                        }

                        var button_url = button.data('url') || button.data('add-url') || button.attr('href');
                        if( button_url ) {
                            ajax(button_url, {onComplete: onComplete, type: type});
                        } else {
                            var form_id = button.data('form-id');
                            if( form_id ) {
                                var formElement = $('#'+form_id);
                            } else {
                                var formElement = button.closest('form');
                            }
                            ajax(formElement.attr('action'), {
                                formData: form.serialize(formElement),
                                onComplete: onComplete,
                                onFailure: onFailure,
                                type: type,
                            });
                        }
                    });
                }

                // Ajax requests may simply done inline or in a modal
                if (button.is('.ajax-modal')) {
                    var modalContent =
                        '<div class="modal-header">' +
                        '  <h4 class="modal-title" id="waiting-title">' +
                        '    <img src="/static/spinner_sm.gif" width="16" height="16">&nbsp;' +
                        button.data('modal-title') +
                        '  </h4>' +
                        '</div>' +
                        '<div class="modal-body">' +
                        button.data('modal-body') +
                        '</div>';
                    var modalNode = $('#waiting-modal');
                    modalNode.find('.modal-content').html(modalContent);
                    modalNode.one('shown.bs.modal', function(e){
                        makeAjaxRequest(button, modalNode);
                    });
                    modalNode.modal('show');
                } else {
                    makeAjaxRequest(button);
                }
            });
        },

        initDownloadButton: function (node) {
            node.find('.download').click(function(e) {
                var button = $(this);
                if (button.hasClass('disabled')) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                require(['components/download'], function(downloadCmp) {
                    downloadCmp(button);
                });
            });
        },

        initInlineEdit: function (node) {
            node.find('.inline-edit').click(function(e) {
                var editable = $(this);
                var editableWidth = editable.outerWidth();
                editable.addClass('hidden');

                if (editable.data('type') == 'textarea') {
                    var formMarkup = '<form class="inline-edit-form" role="form"><textarea name="' + editable.data('name') + '">' + editable.data('value') + '</textarea></form>';
                } else {
                    var formMarkup = '<form class="inline-edit-form" role="form"><input type="text" name="' + editable.data('name') + '" value="' + editable.data('value') + '"></form>';
                }

                editable.after(formMarkup)

                var formNode = editable.next('form');
                if (editable.data('preserve-width')) {
                    formNode.find('input').css({width: editableWidth});
                }

                if (editable.data('type') == 'date') {
                    formNode.find('input').addClass('datepicker-field');
                    form.initDatePicker(formNode);
                    formNode.find('input').on('changeDate', function(e){
                        formNode.submit();
                    });
                }
                formNode.submit(function(e){
                    e.preventDefault();
                    var editable = formNode.prev('.inline-edit');
                    var edit_url = editable.data('url')
                    var formData = new FormData(e.target);
                    require(['components/ajax'], function(ajax) {
                        ajax(edit_url, {
                                formData: formData,
                                onSuccess: function(result) {
                                    editable.data('value', formNode.find('input').val());
                                    if (result.value) {
                                        editable.text(result.value);
                                    } else {
                                        editable.text('Click to edit ' + editable.data('name'));
                                    }
                                    editable.removeClass('hidden');
                                    formNode.remove();
                                },
                                onFailure: function(result) {
                                    formNode.find('input,textarea').before('<span class="inline-edit-error">' + result.error_message + '</span>');
                                }
                            });
                    });
                });

                formNode.find('input:not(.datepicker-field),textarea').blur(function(e) {
                    formNode.submit();
                });
                formNode.find('input,textarea').keyup(function(e) {
                    if (e.which == 27) {
                        editable.removeClass('hidden');
                        formNode.remove();
                    }
                }).focus();
            });

            var utilsComponent = this;
            node.find('.edit-menu-item').click(function(e) {
                var menuItem = $(this);
                var module = $('#'+menuItem.data('module-id'));
                if (module.hasClass('editing')) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();

                var origModuleContent = module.html();

                var initEditView = function() {
                    var moduleComponentName = module.children('div').data('module-component');
                    if (moduleComponentName) {
                        require(['components/'+moduleComponentName], function(component) {
                            component.init(module);
                        });
                    }

                    module.find('button').click(function(e) {
                        var button = $(e.target);
                        if (button.attr('name') == 'save') {
                            e.preventDefault();
                            e.stopPropagation();
                            var formData = form.serialize(button.closest('form'));
                            require(['components/ajax'], function(ajax) {
                                ajax(menuItem.attr('href'), {
                                    formData: formData,
                                    onSuccess: function(result) {
                                        module.html(result.body);
                                        module.removeClass('editing');
                                        if ($('button.transaction_publish').length > 0 && $('#edit-transaction-batch').length === 0 && !$('.expando-details-view').hasClass('hidden')) {
                                            $('button.transaction_publish').prop('disabled', false);
                                        }
                                    },
                                    onFailure: function(result) {
                                        module.html(result.body);
                                        initEditView();
                                    },
                                    onError: function(result) {
                                        module.html(result.body);
                                        initEditView();
                                    },
                                });
                            });
                            return false;
                        }
                        if (button.attr('name') == 'cancel') {
                            e.preventDefault();
                            e.stopPropagation();
                            module.html(origModuleContent);
                            module.removeClass('editing');
                            if ($('button.transaction_publish').length > 0 && $('#edit-transaction-batch').length === 0 && !$('.expando-details-view').hasClass('hidden')) {
                                $('button.transaction_publish').prop('disabled', false);
                            }
                        }
                    });

                    utilsComponent.initRevealHide(module);
                    utilsComponent.initToggleDisabled(module);

                    module.find('form').each(function() {
                        form.init($(this));
                    });

                    // Initialize DOM elements in the module, including popovers
                    require(['components/dom_setup'], function(domSetup) {
                        domSetup.init(module);
                    });

                    form.focusFirstInput(module);
                }

                $.ajax({
                    url: menuItem.attr('href'),
                    type: 'GET',
                    processData: false,
                    success: function(result) {
                        module.html(result.body);
                        module.addClass('editing');
                        initEditView();
                    },
                    error: function(result) {
                    },
                });
            });
        },

        initObfuscatedAddress: function(node) {
            node.find('a.format-addr').each(function() {
                var prefix = $(this).data('prefix');
                var suffix = $(this).data('suffix');

                prefix = prefix.split("").reverse().join("");  // reverse
                if(prefix && suffix) {
                    var emailAddress = prefix + '@' + suffix;
                    $(this).attr('href', 'mailto:' + emailAddress);
                    if(!$(this).text()) {
                        $(this).text(emailAddress);
                    }
                }
            });
        },

        initTrigger: function(node) {
            var SUPPORTED_EVENT_TYPES = ['click', 'blur', 'focus'];
            node.find('.trigger').click(function(e) {
                var eventType = $(this).data('event-type');
                if (SUPPORTED_EVENT_TYPES.indexOf(eventType) == -1 && eventType.slice(0, 4) != 'jsq:' ) {
                    return;
                }
                var targetSelector = $(this).data('event-target');
                $(targetSelector).trigger(eventType, [$(this).data('event-data')]);
            });
        },

        /**
         * Sets other field as checked (or unchecked) when an input having "toggle-checked"
         * (or "toggle-checked-reverse") is checked.
         *
         * @param {*} node
         */
        initToggleChecked: function(node) {
            node.find('input[type=checkbox].toggle-checked, input[type=radio].toggle-checked').click(function() {
                var selector = $(this).data('checked-target');
                var target = $(selector);
                if (target.length > 0) {
                    target.prop('checked', $(this).prop('checked'));
                }
            });

            node.find('input[type=checkbox].toggle-checked-reverse, input[type=radio].toggle-checked-reverse').click(function() {
                var selector = $(this).data('checked-target');
                var target = $(selector);
                if (target.length > 0) {
                    if ($(this).prop('checked') == true) {
                        target.prop('checked', false);
                    }
                }
            });
        },

        initToggleDisabled: function (node) {
            node.find('input[type=checkbox].toggle-disabled, input[type=radio].toggle-disabled').click(function() {
                var selectorToToggle = $(this).data('toggle-target');
                var toggleTarget = $(selectorToToggle);
                if (toggleTarget.length > 0) {
                    if ($(this).prop('checked') == true) {
                        toggleTarget.removeAttr('disabled')
                                    .removeClass('disabled');
                        if ($(selectorToToggle).data('active-state') == 'unchecked') {
                            toggleTarget.prop('checked', false);
                        } else if ($(selectorToToggle).data('active-state') == 'checked') {
                            toggleTarget.prop('checked', true);
                        } else if ($(selectorToToggle).data('active-state') == 'clear') {
                            toggleTarget.val('');
                        }
                    } else {
                        toggleTarget.attr('disabled', 'disabled');
                        if ($(selectorToToggle).data('disabled-state') == 'unchecked') {
                            toggleTarget.prop('checked', false);
                        } else if ($(selectorToToggle).data('disabled-state') == 'checked') {
                            toggleTarget.prop('checked', true);
                        } else if ($(selectorToToggle).data('disabled-state') == 'clear') {
                            toggleTarget.val('');
                        }
                    }
                }
            });

            node.find('input[type=checkbox].toggle-disabled-reverse, input[type=radio].toggle-disabled-reverse').click(function() {
                var selectorToToggle = $(this).data('toggle-target');
                var toggleTarget = $(selectorToToggle);
                if (toggleTarget.length > 0) {
                    if ($(this).prop('checked') == true) {
                        toggleTarget.attr('disabled', 'disabled');
                        if ($(selectorToToggle).data('disabled-state') == 'unchecked') {
                            toggleTarget.prop('checked', false);
                        } else if ($(selectorToToggle).data('disabled-state') == 'checked') {
                            toggleTarget.prop('checked', true);
                        } else if ($(selectorToToggle).data('disabled-state') == 'clear') {
                            toggleTarget.val('');
                        }
                    } else {
                        toggleTarget.removeAttr('disabled');
                    }
                }
            });

            node.find('input:radio.toggle-disabled').on('change, click', function(e) {
                var selectorToDisable = $(this).data('inactive-target');
                if (selectorToDisable){
                    $(selectorToDisable).attr('disabled', 'disabled');
                }
                var selectorToEnable = $(this).data('active-target');
                if (selectorToEnable){
                    $(selectorToEnable).removeAttr('disabled');
                }
            });
        },

        initSelectAll: function (node) {
            node.find('.select-all').click(function() {
                var targetSelector = $(this).data('select-target');
                if (targetSelector) {
                    $(targetSelector).prop('checked', true);
               }
            });
            node.find('.select-none').click(function() {
                var targetSelector = $(this).data('select-target');
                if (targetSelector) {
                    $(targetSelector).prop('checked', false);
               }
            });
        },

        formatCurrency: function(amount, currencySymbol) {
            currencySymbol = currencySymbol || '$';
            var sign = amount < 0 ? "-" : "",
                i = parseInt(amount = Math.abs(+amount || 0).toFixed(2)) + "",
                j = (j = i.length) > 3 ? j % 3 : 0;
            return currencySymbol + sign +
                   (j ? i.substr(0, j) + ',' : "") +
                   i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ',') +
                   ('.' + Math.abs(amount - i).toFixed(2).slice(2));
        },

        parseCurrency: function(amount, currencySymbol) {
            amount = amount || '0';
            currencySymbol = currencySymbol || '$';
            const regex = new RegExp('[' + currencySymbol + ',]', 'g');
            amount = amount.replace(regex,'');
            amount = parseFloat(amount, 10);
            if (isNaN(amount)) {
                amount = 0;
            }
            return amount;
        },

        isCurrencyValid: function(amount) {
            amount = amount || Number.NaN;
            amount = amount.replace(/[$,]/g,'');
            amount = parseFloat(amount, 10);
            return !isNaN(amount);
        },

        hashFormData: function(formData) {
            if (!formData || typeof formData.entries !== 'function') {
                return null;
            }

            var formEntries = formData.entries();
            var formEntriesObject = {};
            var nextEntry = formEntries.next();

            while (nextEntry.done !== true) {
                formEntriesObject[nextEntry.value[0]] = nextEntry.value[1];
                nextEntry = formEntries.next();
            }

            return hash(JSON.stringify(formEntriesObject));

            /**
             * Light-weight hashing function from https://github.com/darkskyapp/string-hash
             */
            function hash(str) {
                var hash = 5381;
                var i = str.length;

                while(i) {
                    hash = (hash * 33) ^ str.charCodeAt(--i);
                }

                return hash >>> 0;
            }
        }
    };

    return utils;
});

